<template>
  <div class="number">
      <div class="tablelist">
            <el-table
            :data="tableData"
            :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
            style="width: 100%">
            <el-table-column
                prop="id"
                label="ID"
                width="120">
            </el-table-column>
            <el-table-column
                prop="shopName"
                label="4S店名称"
                width="150">
            </el-table-column>
            <el-table-column
                prop="loginNumber"
                width="150"
                label="登录账号">
            </el-table-column>
            <el-table-column
               width="450"
                prop="address"
                label="公司地址">
            </el-table-column>
            <el-table-column
                prop=""
                label="操作">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="modifypwd(scope.row)">修改密码</el-link>
                    <el-link :underline="false" @click="editaddress(scope.row)">编辑地址</el-link>
                    <el-link :underline="false" @click="editinfo(scope.row)">编辑账户信息</el-link>
                </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="page">
          <el-pagination
            :background="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
      </div>
      <!-- 编辑弹框 -->
      <el-dialog
        title="编辑地址"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="30%"
        >
        <div class="froms">
            <el-form :model="ruleForm"  label-width="100px" class="demo-ruleForm">
                <el-form-item label="地址">
                    <el-input v-model="ruleForm.address"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button  v-preventReClick @click="dialogVisible = false">取 消</el-button>
            <el-button  v-preventReClick type="primary" @click="submitForm()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改密码 -->
        <el-dialog
        title="修改密码"
        :visible.sync="dialogVisiblepwd"
        :close-on-click-modal="false"
        width="30%"
        >
        <div class="froms">
           <el-form :model="ruleFormpwd" status-icon :rules="rulespwd" ref="ruleFormpwd" label-width="100px" class="demo-ruleForm">
                <el-form-item label="原密码" prop="oldpass">
                    <el-input type="password" v-model="ruleFormpwd.oldpass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pass">
                    <el-input type="password" v-model="ruleFormpwd.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ruleFormpwd.checkPass" autocomplete="off"></el-input>
                </el-form-item>
                </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button  v-preventReClick @click="dialogVisiblepwd = false">取 消</el-button>
            <el-button  v-preventReClick type="primary" @click="submitFormpwd()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑弹出 -->
      <el-dialog
        title="编辑"
        :visible.sync="dialogVisibleedits"
        :close-on-click-modal="false"
        width="30%"
        >
        <div class="info">
            <div class="infoaccount">
                <p>账户信息</p>
                <el-form :model="ruleFormedit" :rules="rulesedit" ref="ruleFormedit" label-width="120px" class="demo-ruleForm">
                    <el-form-item label="公司名称" prop="name">
                        <el-input v-model="ruleFormedit.name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="银行联行号" prop="num1">
                        <el-input v-model="ruleFormedit.num1"></el-input>
                    </el-form-item>
                    <el-form-item label="收款单位名称" prop="name1">
                        <el-input v-model="ruleFormedit.name1"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行" prop="name2">
                        <el-input v-model="ruleFormedit.name2"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行账号" prop="num2">
                        <el-input v-model="ruleFormedit.num2"></el-input>
                    </el-form-item>
                    <p>开票信息</p>
                    <el-form-item label="公司名称" prop="name3">
                        <el-input v-model="ruleFormedit.name3"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税识别号" prop="num3">
                        <el-input v-model="ruleFormedit.num3"></el-input>
                    </el-form-item>
                    <el-form-item label="注册地址" prop="address">
                        <el-input v-model="ruleFormedit.address"></el-input>
                    </el-form-item>
                    <el-form-item label="注册电话" prop="phone">
                        <el-input v-model="ruleFormedit.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行" prop="name4">
                        <el-input v-model="ruleFormedit.name4"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行账号" prop="num4">
                        <el-input v-model="ruleFormedit.num4"></el-input>
                    </el-form-item>
                    <el-form-item label="发票类型" prop="resource">
                        <el-radio-group v-model="ruleFormedit.resource">
                        <el-radio label="专票"></el-radio>
                        <el-radio label="普票"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                     <!-- <p>公司类型</p>
                    <el-form-item label="公司类型" prop="type">
                        <el-checkbox-group v-model="ruleForm.type">
                        <el-checkbox label="鲁诺" name="type"></el-checkbox>
                        <el-checkbox label="黑马" name="type"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item> -->
                </el-form>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button  v-preventReClick @click="dialogVisibleedits = false">取 消</el-button>
            <el-button  v-preventReClick type="primary" @click="submitFormedit()">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import {selectNumber,updatePassword,updateAddress,updateAccountMsg} from '../axios/api'
export default {
    data(){
        var validatePass = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请输入密码'));
            } else {
            if (this.ruleFormpwd.checkPass !== '') {
                this.$refs.ruleFormpwd.validateField('checkPass');
            }
            callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleFormpwd.pass) {
            callback(new Error('两次输入密码不一致!'));
            } else {
            callback();
            }
        };
        return{
            tableData:[],
            total:0,
            page:1,
            currentPage4:1,
            dialogVisible:false,
            dialogVisiblepwd:false,
            ruleForm: {
               address:''
            },
            ruleFormpwd: {
                pass: '',
                checkPass: '',
                oldpass: ''
            },
            rulespwd: {
                pass: [
                    {required: true, validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { required: true,validator: validatePass2, trigger: 'blur' }
                ],
                oldpass: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ]
            },
            dialogVisibleedits:false,
            ruleFormedit: {
                name: '',
                type: [],
                resource: '',
                num1:'',
                name1:'',
                num2:'',
                name2:'',
                name3:'',
                num3:'',
                address:'',
                phone:'',
                name4:'',
                num4:''
            },
            rulesedit: {
                name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                name1: [
                    { required: true, message: '请输入收款单位名称', trigger: 'blur' }
                ],
                name2: [
                    { required: true, message: '请输入开户行名称', trigger: 'blur' }
                ],
                name3: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                name4: [
                    { required: true, message: '请输入开户行', trigger: 'blur' }
                ],
                num1: [
                    { required: true, message: '请输入银行联行号', trigger: 'blur' }
                ],
                num2: [
                    { required: true, message: '请输入开户账号', trigger: 'blur' }
                ],
                num3: [
                    { required: true, message: '请输入纳税识别号', trigger: 'blur' }
                ],
                num4: [
                    { required: true, message: '请输入开户行账号', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请输入注册地址', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入注册电话', trigger: 'blur' }
                ],
                resource: [
                    { required: true, message: '请选择发票类型', trigger: 'change' }
                ]
            },
            editid:''
        }
    },
    created(){
        this.getdata()
    },
    methods:{
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        modifypwd(){
            this.dialogVisiblepwd = true
        },
        editaddress(row){
            this.dialogVisible = true
            this.ruleForm.address = row.address
        },
       async submitForm(){
            var {data:dt} = await updateAddress({
                address:this.ruleForm.address,
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.dialogVisible = false
                this.$message.success(dt.message)
                this.getdata()
            }
        },
        submitFormpwd(){
            this.$refs.ruleFormpwd.validate(async (valid) => {
                if (valid) {
                    var {data:dt} = await updatePassword({
                        newPassword:this.ruleFormpwd.pass,
                        oldPassword:this.ruleFormpwd.oldpass,
                        userId:window.localStorage.getItem('shopId')
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message.success(dt.message)
                        this.dialogVisiblepwd = false
                                     window.localStorage.removeItem('name')
                                     window.localStorage.removeItem('loginNumber')
                                     window.localStorage.removeItem('token')
                                     window.localStorage.removeItem('shopId')
                                     window.localStorage.removeItem('state')
                                     window.localStorage.removeItem('ids')
                                     window.localStorage.removeItem('month')
                                     window.localStorage.removeItem('months')
                        setTimeout(()=>{
                            this.$router.push('/login')
                        },2000)
                        
                    }else{
                        this.$message.error(dt.message)
                    }
                    
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async getdata(){
            var {data:dt} = await selectNumber({
                loginNumber:window.localStorage.getItem('loginNumber')
            })
            console.log(dt)
            if(dt.code == 200){
                this.tableData = []
                this.tableData.push(dt.data.shopAdmin)
                this.total = 1
            }
        },
        editinfo(row){
            console.log(row)
            this.editid = row.account.id
            this.dialogVisibleedits = true
            this.ruleFormedit.name = row.account.shopName
            this.ruleFormedit.num1 = row.account.bankNumber
            this.ruleFormedit.name1 = row.account.payeeName
            this.ruleFormedit.name2 = row.account.openBankAcc
            this.ruleFormedit.num2 = row.account.openAccount

            this.ruleFormedit.name3 = row.account.firmName
            this.ruleFormedit.num3 = row.account.ratepayNumber
            this.ruleFormedit.address = row.account.address
            this.ruleFormedit.phone = row.account.phone
            this.ruleFormedit.name4 = row.account.openBankInv
            this.ruleFormedit.num4 =row.account.openBankNum
            this.ruleFormedit.resource = row.account.invoiceType == 1?'专票':row.account.invoiceType == 2?'普票':'专票'
                },
        submitFormedit() {
            this.$refs.ruleFormedit.validate(async (valid) => {
            if (valid) {
                var {data:dt} = await updateAccountMsg({
                    id:this.editid,
                    bankNumber: this.ruleFormedit.num1,
                    payeeName:this.ruleFormedit.name1,
                    openBankAcc:this.ruleFormedit.name2,
                    openAccount:this.ruleFormedit.num2,
                    firmName:this.ruleFormedit.name3,
                    ratepayNumber:this.ruleFormedit.num3,
                    address:this.ruleFormedit.address,
                    phone:this.ruleFormedit.phone,
                    openBankInv:this.ruleFormedit.name4,
                    openBankNum:this.ruleFormedit.num4,
                    invoiceType:this.ruleFormedit.resource == '专票'? 1:2
                })
                console.log(dt)
                if(dt.code == 200){
                    this.$message.success(dt.message)
                    this.dialogVisibleedits = false
                    this.getdata()
                }
            }
            });
        },
    }
}

</script>
<style lang="less" scoped>
.number{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link.el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    }
}
</style>